module.exports = __webpack_public_path__ + "img/Natural-Wood.4fe0c933.jpg";